export const ENDPOINTS = {
  OAUTH: {
    AUTHORIZE_CLIENT: '/oauth/v1/authorize',
    INTEGRATION_CLIENT: '/oauth/v1/integration-clients/:id',
    LOGIN: '/oauth/v1/login',
    MFA: '/oauth/v1/login/callback/mfa',
  },
  TCPA: {
    LEGAL_LIABILITY: '/clients/tcpa-liability-acceptance-language',
    TCPA_ACCEPT: '/clients/v1/:clientId/accept-tcpa-liability',
  },
} as const
